/**
 =========================================================
 * Material Dashboard 2 React - v2.1.0
 =========================================================

 * Product Page: https://www.creative-tim.com/product/material-dashboard-react
 * Copyright 2022 Creative Tim (https://www.creative-tim.com)

 Coded by www.creative-tim.com

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 */

import {forwardRef} from "react";

// prop-types is a library for typechecking of props

import MDBoxRoot from "./MDBoxRoot";
// Custom styles for MDBox
const MDBox = forwardRef(
    (
        {
            variant,
            bgColor,
            color,
            opacity,
            borderRadius,
            shadow,
            coloredShadow,
            ...rest
        },
        ref
    ) => (
        <MDBoxRoot
            {...rest}
            ref={ref}
            ownerState={{
                variant,
                bgColor,
                color,
                opacity,
                borderRadius,
                shadow,
                coloredShadow,
            }}
        />
    )
);

export default MDBox;
